<template>
  <div class="default_div">
    <img
      src="../../static/talks/t_defaultIcon.png"
      style="width: 262px; height: 266px"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style>
.default_div {
  width: 100%;
  height: 100%;
  /* background: #F7FBF7 ; */
  background-color: #fff;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
</style>
